import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";

import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";

export type DashBoardTable = {
  topHeader: string[];
  data: any;
  /**
   * Optional so the printed Final Submitted report keeps rendering exactly as
   * before. The Actions column only appears when this is supplied. There is no
   * edit counterpart here: the admin portal reviews committee members, only the
   * Implementing Officer / Entity who added one can change it.
   */
  onViewHistory?: (row: any) => void;
};

export function MonitoringMemberDetailsTable({
  data,
  topHeader,
  onViewHistory,
}: DashBoardTable) {
  const styles = getStyles(defaultStyles);

  return (
    <TableContainer
      component={Paper}
      sx={{ height: "fit-content", mt: "20px" }}
    >
      <Table sx={{ minWidth: 600 }} aria-label="simple table">
        <TableHead {...styles("header")}>
          <TableRow>
            {topHeader.map((item, index) => (
              <TableCell align="center" {...styles("cell")} key={index}>
                {item}
              </TableCell>
            ))}
            {onViewHistory && (
              <TableCell align="center" {...styles("cell")}>
                Actions
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.length > 0 &&
            data.map((item, index) => {
              if (!item) return null;
              return (
                <TableRow key={index}>
                  <TableCell
                    align="center"
                    {...styles("cell", { width: "30px" })}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell
                    align="center"
                    {...styles("cell", { width: "100px" })}
                  >
                    {item.name}
                  </TableCell>
                  <TableCell
                    align="center"
                    {...styles("cell", { width: "100px" })}
                  >
                    {item.designation}
                  </TableCell>
                  <TableCell
                    align="center"
                    {...styles("cell", { width: "100px" })}
                  >
                    {item.phoneNumber}
                  </TableCell>
                  <TableCell
                    align="center"
                    {...styles("cell", { width: "100px" })}
                  >
                    {item.email}
                  </TableCell>
                  {onViewHistory && (
                    <TableCell
                      align="center"
                      {...styles("cell", { width: "110px" })}
                    >
                      <Tooltip title="View update history">
                        <IconButton
                          aria-label="view update history"
                          onClick={() => onViewHistory(item)}
                        >
                          <HistoryIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
